import React from 'react';
import Login from '../components/layout/Login';
import ResetPassword from '../components/layout/ResetPassword';

class McCORD_Login extends React.Component {
  render()
  {
  return (
    <div className="McCORD_Login">

      <Login/>

    </div>
  );
 }
}

export default McCORD_Login;